import React, { Component } from 'react'
import {
    Button,
    Card,
    CardBody,
    Icon,
    Row,
    Col,
    ModalHeader,
    ModalBody,
    Modal,
    Container,
} from 'design-react-kit';
import { NavLink } from 'react-router-dom';
import orgchart_png from '../../../theme/images/orgchart-icon.png'
import { getRelativeURL } from 'design-comuni-plone-theme/components';
import { OrganigrammaModalView } from 'uniba-volto-persone/components';
import { Helmet } from '@plone/volto/helpers';
import unibalogo from '../../../theme/images/unibalogo.svg';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class StrutturaView extends Component {
    constructor(props) {
        super(props);

        const content = props.content || props.props;
        const searchParams = new URLSearchParams(props.location.search);

        this.state = {
            isOpenOrgani: searchParams.has('organigramma'),
            content: content,
            enableOrganigramma: false,
        };
    };

    toggleOrgani = () => {
        this.setState((prevState) => ({
            isOpenOrgani: !prevState.isOpenOrgani,
        }));
    };

    render() {
        const { userSession, intl } = this.props;
        const { isOpenOrgani, content, enableOrganigramma } = this.state;
        const isAnon = userSession.token == null;

        const usersAfferentiBaseUrl = '/rubrica/?indexChainBelongs=';
        const usersAfferentiComplessivoUrl = usersAfferentiBaseUrl + content.UID;

        const sommaAfferentiSottostrutture = content.items?.reduce(
            (sum, item) => sum + (item.numPersoneAfferentiGlobali || 0),
            0
        );

        const intl_orgTitle = intl.formatMessage({ id: 'organigrammaTitle' });
        const intl_respLabel = intl.formatMessage({ id: 'strutturaResponsabileLabel' });
        const intl_goSottostrutt = intl.formatMessage({ id: 'strutturaGoSottostruttura' });
        const intl_goComplessivo = intl.formatMessage(
            { id: 'strutturaGoSottostrutturaAff' },
            {
                numAfferenti: content.numPersoneAfferenti + sommaAfferentiSottostrutture,
                struttura: content.title,
            }
        );

        return (
            <>
                <Helmet>
                    <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <Container>
                    <Row>
                        <Col xs="12">
                            <Card className="shadow">
                                <div
                                    className="strutture-title my-4 
                                        position-relative d-flex 
                                        align-items-center px-2"
                                >
                                    <img
                                        src={unibalogo}
                                        className="position-absolute strutture-logo"
                                        aria-hidden="true"
                                        alt=""
                                    />
                                    <h5
                                        className="mb-0 strutture-name 
                                            py-2 fs-4 lh-1 d-flex 
                                            align-items-center"
                                    >
                                        <span className="d-inline-block">
                                            {content.title}
                                        </span>
                                        {(!isAnon && enableOrganigramma) && (
                                            <Button
                                                onClick={this.toggleOrgani}
                                                className="d-inline-flex 
                                                    align-items-center 
                                                    btn-icontext bg-white 
                                                    border border-2 
                                                    border-primary ms-3 ps-2"
                                                title={intl_orgTitle}
                                                aria-label={intl_orgTitle}
                                            >
                                                <img
                                                    width={24}
                                                    height={24}
                                                    src={orgchart_png}
                                                    alt=""
                                                />
                                                <span
                                                    className="d-md-block d-none"
                                                >
                                                    {intl.formatMessage(
                                                        { id: 'organigramma' }
                                                    )}
                                                </span>
                                            </Button>
                                        )}
                                    </h5>
                                </div>
                                <CardBody>
                                    <div className="struttura-info">
                                        {content.sitoweb && (
                                            <div
                                                className="d-flex align-items-center lh-1 mb-2"
                                                role="group"
                                                aria-labelledby="website-label"
                                            >
                                                <i
                                                    className="bi bi-globe 
                                                        fs-2 text-primary"
                                                    aria-hidden="true"
                                                />
                                                <h5
                                                    id="website-label"
                                                    className="mx-2 mb-0 lh-1"
                                                >
                                                    {intl.formatMessage(
                                                        { id: 'strutturaSitoWebLabel' }
                                                    )}
                                                </h5>
                                                <a
                                                    className="lh-1"
                                                    href={content.sitoweb}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    aria-labelledby="website-label"
                                                >
                                                    {content.sitoweb}
                                                </a>
                                            </div>
                                        )}
                                        {!isAnon && (
                                            <>
                                                <div
                                                    className="d-flex align-items-center lh-1 mb-2"
                                                    role="group"
                                                    aria-labelledby="can-have-aff-label"
                                                >
                                                    <i
                                                        className="bi bi-person-fill-add fs-2 text-primary"
                                                        aria-hidden="true"
                                                    />
                                                    <h5
                                                        id="can-have-aff-label"
                                                        className="mx-2 mb-0 lh-1"
                                                    >
                                                        {intl.formatMessage(
                                                            { id: 'strutturaPuoAfferentiLabel' }
                                                        )}
                                                    </h5>
                                                    <p
                                                        className="text-muted mb-0 lh-1"
                                                    >
                                                        {' '}
                                                        {intl.formatMessage(
                                                            {
                                                                id: content.canHaveAfferenti ?
                                                                    'feedback_form_yes' :
                                                                    'feedback_form_no'
                                                            }
                                                        )}
                                                    </p>
                                                </div>

                                                {content.codiceStruttura && (
                                                    <div
                                                        className="d-flex align-items-center lh-1 mb-2"
                                                        role="group"
                                                        aria-labelledby="structure-code-label"
                                                    >
                                                        <i
                                                            className="bi bi-upc fs-2 text-primary"
                                                            aria-hidden="true"
                                                        />
                                                        <h5
                                                            id="structure-code-label"
                                                            className="mx-2 mb-0 lh-1"
                                                        >
                                                            {intl.formatMessage(
                                                                { id: 'strutturaCodiceStrutturaLabel' }
                                                            )}
                                                        </h5>
                                                        <p
                                                            className="text-muted mb-0 lh-1"
                                                        >
                                                            {' '}
                                                            {content.codiceStruttura}
                                                        </p>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                        {content.email && (
                                            <div
                                                className="d-flex align-items-center lh-1 mb-2"
                                                role="group"
                                                aria-labelledby="email-label"
                                            >
                                                <i
                                                    className="bi bi-envelope fs-2 text-primary"
                                                    aria-hidden="true"
                                                />
                                                <h5
                                                    id="email-label"
                                                    className="mx-2 mb-0 lh-1"
                                                >
                                                    {intl.formatMessage(
                                                        { id: 'strutturaEmailUfficioLabel' }
                                                    )}
                                                </h5>
                                                <a
                                                    className="lh-1"
                                                    href={`mailto:${content.email}`}
                                                    aria-labelledby="email-label"
                                                >
                                                    {' '}
                                                    {content.email}
                                                </a>
                                            </div>
                                        )}
                                        {content.orariApertura && (
                                            <div
                                                className="d-flex align-items-center lh-1 mb-2"
                                                role="group"
                                                aria-labelledby="orariApertura-label"
                                            >
                                                <i
                                                    className="bi bi-calendar4-week fs-2 text-primary"
                                                    aria-hidden="true"
                                                />
                                                <h5
                                                    id="orariApertura-label"
                                                    className="mx-2 mb-0 lh-1"
                                                >
                                                    {intl.formatMessage(
                                                        { id: 'strutturaOrariApertura' }
                                                    )}
                                                </h5>
                                                <p
                                                    className="text-muted mb-0 lh-1"
                                                >
                                                    {' '}
                                                    {content.orariApertura}
                                                </p>
                                            </div>
                                        )}
                                        {content.responsabile && (
                                            <div
                                                className="d-flex align-items-center lh-1 mb-2"
                                                role="group"
                                                aria-labelledby="responsabile-label">
                                                <i
                                                    className="bi bi-person-bounding-box fs-2 text-primary"
                                                    aria-hidden="true"
                                                />
                                                <h5
                                                    id="responsabile-label"
                                                    className="mx-2 mb-0 lh-1"
                                                >
                                                    {intl_respLabel}
                                                </h5>
                                                <NavLink
                                                    className="lh-1"
                                                    to={`/rubrica/${content.responsabile.id}`}
                                                    aria-describedby="responsabile-label"
                                                >
                                                    {' '}
                                                    <span className="visually-hidden">{intl_respLabel}: </span>
                                                    {content.responsabile.title}
                                                </NavLink>
                                            </div>
                                        )}
                                        {content.items && content.items.length > 0 && (
                                            <div
                                                className="mb-2"
                                                role="group"
                                                aria-labelledby="sottostrutture-label"
                                            >
                                                <div
                                                    className="d-flex align-items-center lh-1"
                                                >
                                                    <i
                                                        className="bi bi-bank fs-2 text-primary"
                                                        aria-hidden="true"
                                                    />
                                                    <h5
                                                        id="sottostrutture-label"
                                                        className="mx-2 mb-0 lh-1"
                                                    >
                                                        {intl.formatMessage(
                                                            { id: 'strutturaSottostruttureLabel' }
                                                        )}
                                                    </h5>
                                                </div>
                                                <div
                                                    className="alert alert-info alert-sottostrutture ms-5"
                                                    role="note"
                                                    aria-live="polite"
                                                >
                                                    {intl.formatMessage(
                                                        { id: 'strutturaSottostruttureSubLabel' }
                                                    )}
                                                </div>
                                                <ul
                                                    className="list-group list-group-flush ms-0 sottostrutture-list"
                                                    aria-labelledby="sottostrutture-label"
                                                >
                                                    {content.items.map((item) => {
                                                        const usersAfferentiSottostrutturaUrl = usersAfferentiBaseUrl + item.UID;
                                                        const sottostrutturaRedirect = getRelativeURL(item['@id']);
                                                        const intl_goSottostruttAff = intl.formatMessage(
                                                            { id: 'strutturaGoSottostrutturaAff' },
                                                            {
                                                                numAfferenti: item.numPersoneAfferentiGlobali,
                                                                struttura: item.title,
                                                            }
                                                        );
                                                        return (
                                                            <li
                                                                className="list-group-item p-0 border-0 ms-5 d-flex flex-row"
                                                                key={item.UID}
                                                            >
                                                                <NavLink
                                                                    to={sottostrutturaRedirect}
                                                                    aria-label={`${intl_goSottostrutt}: ${item.title}`}
                                                                >
                                                                    {item.title}
                                                                </NavLink>
                                                                &nbsp;
                                                                <NavLink
                                                                    to={usersAfferentiSottostrutturaUrl}
                                                                    tag="a"
                                                                    aria-label={intl_goSottostruttAff}
                                                                >
                                                                    <b>
                                                                        (
                                                                        <Icon className="lens" icon="it-search" size="xs" aria-hidden="true" />
                                                                        {item.numPersoneAfferentiGlobali}
                                                                        )
                                                                    </b>
                                                                </NavLink>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                        )}

                                        <div
                                            className="d-flex align-items-center lh-1"
                                            role="group"
                                            aria-labelledby="complessivo-label"
                                        >
                                            <i
                                                className="bi bi-people fs-2 text-primary"
                                                aria-hidden="true"
                                            />
                                            <h5
                                                id="complessivo-label"
                                                className="mx-2 mb-0 lh-1"
                                            >
                                                {intl.formatMessage(
                                                    { id: 'strutturaComplessivoLabel' }
                                                )}
                                                {' '}
                                                (
                                                <NavLink
                                                    className="lh-1"
                                                    to={usersAfferentiComplessivoUrl}
                                                    tag="a"
                                                    aria-label={intl_goComplessivo}
                                                    title={intl_goComplessivo}
                                                >
                                                    <Icon className="lens" icon="it-search" size="xs" aria-hidden="true" />
                                                    {content.numPersoneAfferenti + sommaAfferentiSottostrutture}
                                                </NavLink>
                                                )
                                            </h5>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>

                            {!isAnon && (
                                <Modal isOpen={isOpenOrgani} toggle={this.toggleOrgani} className="modal-fullscreen">
                                    <ModalHeader toggle={this.toggleOrgani} />
                                    <ModalBody className="p-0">
                                        <OrganigrammaModalView />
                                    </ModalBody>
                                </Modal>
                            )}
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

StrutturaView.propTypes = {
    // Data
    content: PropTypes.object.isRequired,

    // Routing / Internazionalizzazione
    intl: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,

    // Redux store
    userSession: PropTypes.object,
};

StrutturaView.defaultProps = {
    showViewLink: true,
};


export default connect(
    (state) => ({
        userSession: state.userSession,
    })
)(injectIntl(withRouter(StrutturaView)));